import React, { useContext } from "react";
import Stats from "../../../blocks/stats";
import UserContext from "../../../components/TheUser";
import { Popover } from "@headlessui/react";
import Breadcrums from "../../../components/breadcrums";
import PageTitle from "../../../components/pageTitle";
import classNames from "classnames";
import { sectionClass, paymentsCommands } from "../../../constants/common";
import { paymentStatusBreadcrums } from "../../../constants/breadcrums";

export default function PaymentStatus() {
    const userData = useContext(UserContext);

    return (
        <main>
            <Breadcrums breadcrumLinks={paymentStatusBreadcrums} commands={paymentsCommands} groups={["Actions", "Statement"]} />
            <PageTitle title="Payment Status" preSummary="Payment Status Dashboard" summary="Track and monitor all payment statuses">
                {/* , July 2023 */}
            </PageTitle>

            <section className={classNames(sectionClass)}>
                <Stats />
            </section>

            {/* <section>
                <h1>{JSON.stringify(userData)}</h1>
            </section> */}
        </main>
    );
}
